export default __webpack_public_path__ + "static/media/en_grade.4a20fd99.png";